export const LIST = "PERMISSION_LIST";
export const DETAILS = "PERMISSION_DETAILS";
export const UPDATE = "PERMISSION_UPDATE";
export const STORE = "PERMISSION_STORE";